<template>
  <div class="col-sm-9 col-md-7 col-lg-9 product-content">
    <div class="row">
      <!-- Items -->
      <router-link
        tag="div"
        v-for="(item, index) in items"
        :key="index"
        class="col-lg-3 col-sm-12 col-md-6 mb-4 product-box"
        v-show="item.available"
        :to="`/product/${$route.params.username}/${item.business_id}/${item.id}`"
      >
        <div class="product-box-num">
          <div class="product-box-img">
            <img :src="getImageUrl(item.main_img, 'product', 'product.jpg')" :alt="item.title" />
          </div>
          <div class="product-box-icon d-flex">
            <i class="icon-plus" @click.prevent="addToCard(item.id , item.business_id)"></i>
            <i
              v-if="!item.is_like"
              class="icon-heart"
              @click.prevent="addLike(item.id)"
            ></i>
          </div>

          <div class="product-box-text d-flex">
            <i v-if="item.is_like" class="icon-info"></i>
            <i v-else class="icon-heart"></i>
            <p v-text="item.title"></p>
          </div>
          <div class="product-box-text">
            <p>{{ item.stock > 0 ? "موجود" : "ناموجود" }}</p>
          </div>

          <div class="product-box-price d-flex">
            <div class="discount d-flex" v-if="item.discount > 0">
              <span>{{ `${item.discount} %تخفیف` }}</span>
            </div>
            <div class="price d-flex">
              <span class="decoration" v-if="item.discount > 0">{{
               `${price(item.price)} تومان`
              }}</span>
              <span>{{ `${finalPrice(item.final_price)} تومان` }}</span>
            </div>
          </div>
        </div>
      </router-link>
      <!-- Items -->
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import {  formErrors, url, getImageUrl } from "@/mixins.js";

export default {
  name: "Items",
  props: ["items"],
  mixins: [formErrors, url, getImageUrl],

  data() {
    return {
      proError: {
        login_err: "ابتدا وارد حساب کاربری خود شوید.",
      },
      changBscet: 0
    };
  },
  methods: {
    price(price) {
      let dis = new Intl.NumberFormat("ir-RL", {
        maximumSignificantDigits: 3,
      }).format(price);
      return `${dis} `;
    },
    finalPrice(final_price) {
      let dis = new Intl.NumberFormat("ir-RL", {
        maximumSignificantDigits: 3,
      }).format(final_price);
      return `${dis} `;
    },

    async addToCard(pid , bid) {

      let data= new FormData();
      data.append("pid" , pid );
      data.append("bid" , bid );
      data.append("action" , 'add_to_cart' )

      await axios.post("cart/user/add-to-cart.php" , data)
      .then((data) => {
        // console.log("data:" , data.data);
        switch (data.data.msg) {
            case "success":
              this.$snotify.success('محصول شما به سبد خرید اضافه شد.');
              this.$root.$emit("addtocart")
              break;

            case "unable_to_set":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "login_err":
              this.$root.$emit("bv::show::modal", "signin-real-person");
              this.$snotify.warning('ابتدا وارد سایت شوید.');
              break;

            default:
              this.$snotify.error("خطا در خواندن");
          }
      })
    },

    // async readCouunt(bid){
    //   let data= new FormData();
    //   data.append("bid" , bid);
    //   await axios.post("cart/user/count-items.php" , data)
    //   .then((data) => {
    //     console.log("count:" , data.data)

    //   })
    // },
    async addLike(pid) {
      if (!pid) return;

      await axios
        .post("business/product/create_like.php", { product_id: pid })
        .then((data) => {
          console.log("create_like:", data.data);
          switch (data.data.msg) {
            case "success":
            case "already_liked":
              this.$snotify.success('پسندیده شد.');
              break;

            case "unable_to_set":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "login_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            default:
              this.$snotify.error("خطا در خواندن");
          }
        })
        .catch((err) => console.error("Response Error create_like::", err));
    },
  },
  watch: {

  },

};
</script>